import type { Segment } from './types'

// Presentation only: recorder rollover gaps should not flash an empty preview.
// Keep the real start for sampling; gap seeks already snap to the next clip.
const rolloverGapMs = 2000

/** Input is the sorted, non-overlapping output of buildSegments. */
export function timelineSegments(segments: Segment[]) {
  return segments.map((segment, index) => {
    const previous = segments[index - 1]
    const gap = previous ? segment.start - previous.end : Infinity
    return {
      ...segment,
      start: gap > 0 && gap <= rolloverGapMs ? previous.end : segment.start,
      previewStart: segment.start,
    }
  })
}
